"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Icon = __importStar(require("@icr-ui/icons"));
const typography_1 = require("../typography");
const styles_1 = require("./styles");
// Default gutter bottom is 32px
exports.TextField = (0, react_1.forwardRef)((props, ref) => {
    const { iconClickAction, customIcon, label, customInputProps, type = 'text', helperText = undefined, messageType = undefined, showIconPassword = false, isValid = false, isRequired = false, isFilled = false, disabled, onChange, customStyles = {}, disableValidation = false, } = props;
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    const [isValueFilled, setIsValueFilled] = (0, react_1.useState)(isFilled);
    const hasIcon = showIconPassword || customIcon || isValid;
    const hasLabel = !!label;
    const handleShowPassword = () => {
        if (setShowPassword)
            setShowPassword(!showPassword);
    };
    const handleIconClick = (e) => {
        e.preventDefault();
        if (showIconPassword) {
            handleShowPassword();
        }
        else {
            if (iconClickAction)
                iconClickAction();
        }
    };
    function handleType(type) {
        if (type === 'password' && showPassword) {
            return 'text';
        }
        if (type === 'password' && !showPassword) {
            return 'password';
        }
        if (type === 'number-with-unit') {
            return 'number';
        }
        return type;
    }
    const handleChange = (e) => {
        if (e.target.value) {
            setIsValueFilled(false);
        }
        onChange(e);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledTextFieldWrapper, { flexDirection: "row", fullWidth: true, alignItems: "flex-start", ...{ ref, customStyles, disableValidation, hasLabel }, "data-testid": "text-field-wrapper", "aria-label": "text-field-wrapper", children: [label ? ((0, jsx_runtime_1.jsx)(typography_1.Typography, { as: "label", variant: "body", size: "small", weight: "medium", colorScheme: {
                    type: 'text',
                    color: 'label',
                }, "data-testid": "text-field-label", isRequired: isRequired, children: label })) : null, (0, jsx_runtime_1.jsx)(styles_1.StyledTextField, { disabled: disabled, isValueFilled: isValueFilled, ...props, hasIcon: true, type: handleType(type), autoComplete: "off", onChange: e => handleChange(e), ...customInputProps, numberWithUnit: type === 'number-with-unit' }), type === 'number-with-unit' && ((0, jsx_runtime_1.jsx)(styles_1.StyledUnitText, { "data-testid": "text-field-unit", variant: "body", size: "normal", weight: "medium", ...{ disabled }, children: "Unit" })), hasIcon && ((0, jsx_runtime_1.jsxs)(styles_1.StyledTextFieldIcon, { onClick: handleIconClick, noLabel: !hasLabel, type: "button", children: [showIconPassword && type === 'password' && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showPassword ? (0, jsx_runtime_1.jsx)(Icon.EyeHideIcon, {}) : (0, jsx_runtime_1.jsx)(Icon.EyeShowIcon, {}) })), customIcon && customIcon, !customIcon && !showIconPassword && !!isValid && (0, jsx_runtime_1.jsx)(Icon.CheckmarkIcon, {})] })), !disableValidation && ((0, jsx_runtime_1.jsx)(styles_1.StyledTextFieldHelperText, { alignItems: "flex-start", justifyContent: "flex-start", ...{ messageType, helperText }, "data-testid": "text-field-helper-text", children: (0, jsx_runtime_1.jsx)(typography_1.Typography, { variant: "body", size: "small", as: "small", weight: "medium", colorScheme: {
                        type: 'system',
                        color: messageType !== null && messageType !== void 0 ? messageType : 'info',
                    }, children: helperText && helperText }) }))] }));
});
exports.TextField.displayName = 'TextField';
exports.default = exports.TextField;
//# sourceMappingURL=text-field.js.map